import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { catchError, map, Observable, of, switchMap } from 'rxjs';

import { AuthService } from '@services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthAdminGuard implements CanActivate {
  private router = inject(Router);
  private authService = inject(AuthService);

  canActivate(): Observable<boolean> {
    return this.getCurrentUser().pipe(
      switchMap(() => {
        return of(true);
      }),
      catchError(() => {
        return of(false);
      })
    );
  }

  getCurrentUser(): Observable<string> {
    return this.authService.getCurrentUser().pipe(
      map(user => {
        if (!user) {
          this.router.navigate(['/auth/login']);
        } else {
          const role = this.authService.getCurrentRole();
          if (!role) {
            this.router.navigate(['/auth/login']);
            this.authService.logOut();
            return;
          }
          if (role === 'ADMIN') {
            return user;
          } else {
            this.router.navigate(['/v/']);
          }
        }
      })
    );
  }
}
